// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","88":"240c7a09","202":"79225441","274":"8ca5e8a0","325":"9b70fc78"}[chunkId] + ".chunk.js";
};